// material
import { Stack, Button, Toolbar, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import "./Membership.css";

// ----------------------------------------------------------------------
const AnimationStyle = styled(Stack)(({ theme }) => ({
  "@media (max-width: 500px)": {
    display: "none",
  },
  "@keyframes spin": {
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function MembershipSub() {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      sx={{ borderBottom: "1px solid #ffffff80" }}
    >
      <Stack sx={{ width: { xs: "100%", md: "37%" } }}>
        <div className="ms_title">
          AN NFT MEMBERSHIP FOR <br />
          THE CREATIVE COMMUNITY
        </div>
        <Stack spacing={3} sx={{ px: "6%", py: "3%" }}>
          <p className="ms_content">
            Your R/HOOD Membership NFT will be an art piece featuring you. We
            are building this brand for the long run, and we therefore want you
            to hold this membership forever, and be a part of this journey with
            us. That’s why your membership will be an illustration of you -
            because you are a core pillar in our community.
          </p>
          <p className="ms_content">
            In total, we will create 10.000 memberships with characters and
            styles from our various local neighbourhood’s. 33% will have a
            variety of rare traits, as an homage to all the Culture Makers that
            have shaped the world to the beautiful place it is today.
          </p>
          <p className="ms_content">
            Each month - we are dropping 100 new membership cards. These are
            apply-only memberships, as we want to carefully create the most
            engaged community out there.
          </p>
        </Stack>
      </Stack>

      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          borderRight: "1px solid #ffffff80",
          width: { xs: "100%", md: "46%" },
        }}
      >
        <img src="/assets/2-2.png" style={{ width: "100%", height: "100%" }} />
      </Stack>
      <Stack sx={{ width: { xs: "100%", md: "17%" } }}>
        <Stack
          sx={{
            borderBottom: "1px solid #ffffff80",
            py: { xs: "6%", md: "12%" },
            textAlign: "center",
          }}
        >
          <Button
            variant="text"
            sx={{
              color: "#fff",
              fontFamily: "Helvetica",
              lineHeight: 1,
              fontSize: { xs: "30px", md: "24px", lg: "28px", xl: "33px" },
            }}
          >
            MINT YOUR <br />
            MEMBERSHIP
          </Button>
        </Stack>
        <Stack
          sx={{
            borderBottom: { xs: "0px", md: "1px solid #ffffff80" },
            py: { xs: "10%", md: "45%" },
            fontFamily: "Helvetica",
            fontSize: { xs: "30px", md: "24px", lg: "28px", xl: "33px" },
            textAlign: "center",
            color: "#fff",
            lineHeight: 1,
          }}
        >
          0.1 ETH
        </Stack>
        <Stack justifyContent="center" alignItems="center" height="100%">
          <AnimationStyle>
            <Box
              component="img"
              alt="text"
              src="/assets/text.png"
              sx={{
                width: { xs: "80px", lg: "100px", xl: "130px" },
                height: { xs: "80px", lg: "100px", xl: "130px" },
                animation: "spin 12s linear infinite",
              }}
            />
          </AnimationStyle>
        </Stack>
      </Stack>
    </Stack>
  );
}
